<template lang="pug">
div
  .form-box.mb-3
    p.form-til {{ $t('ui.payment_channel') }} :
    .statistic
      template(v-if="providerList.length > 0")
        .s-data(v-for="(method, index) in providerList" :class="{'active' : method.provider_group == paymentId}" @click="switchChannel(method.provider_group)")
          span.s-amount
            i.fas.fa-thumbs-up.u-amo(v-if="method.is_recommend") 
            span(v-if="checkList(method.provider_group)") &nbsp;{{ displayName[method.provider_group] }}
            span(v-else)  &nbsp;{{ method.provider_group }}
  .form-box.mb-3
    .af-form
      p.form-til {{$t('ui.choose_promo')}} :
      .input-group.mb-3
        select.form-select.form-control(v-model="promoSelected" @change="checkDetails")
          option(value="") {{$t('ui.choose_nopromo')}}
          template(v-for="(promo, index) in promotionList")
            option(v-if="promo.promotion_id!==null && promo.status ===  1 && checkAvailability(promo.payment_option_list, promo.payment_gateway_list,promo.claim_type)" :value="promo.promotion_id") {{promo.promotion_name}}
  .form-box.mb-3(v-if="showDetails")
    p.form-til.capitalize {{$t('ui.progress')}}
    .statistic
      .s-data(v-for="detail in promoDetails" :class="{'active' : detail.status !== 0}")
        span.s-amount {{ formatDisplay(detail.item_order, detail.rate) }}
  .form-box.mb-3
    .af-form
      template(v-if="maxRequired !== 0")
        p.form-til {{ $t('ui.deposit_amount') }} {{minRequired}} - {{maxRequired}} 
        .input-group.mb-3
          input.form-control(type='text' :placeholder="$t('ui.amount_min')+': '+minRequired + ', ' + $t('ui.amount_max_short') + ': '+ maxRequired" v-model.trim="$v.depoAmount.$model"  @input="onlyNum")
      template(v-else)
        p.form-til {{ $t('ui.amount') }} ({{$t('ui.amount_min')}}: {{minRequired}})
        .input-group
          input.form-control(type='text' :placeholder="$t('ui.amount_min')+': '+minRequired" v-model.trim="$v.depoAmount.$model"  @input="onlyNum")
      .text-start.mb-3
        validation(v-if="maxRequired !== 0" :value="$v.depoAmount" :name="$t('ui.amount')" target="DEPOSITCP")
        validation(v-else :value="$v.depoAmount" :name="$t('ui.amount')" target="DEPOSIT")
      .d-amount.mb-3
        a(href="javascript:void(0)" @click="fillAmount(100)") 100
        a(href="javascript:void(0)" @click="fillAmount(200)") 200
        a(href="javascript:void(0)" @click="fillAmount(500)") 500
        a(href="javascript:void(0)" @click="fillAmount(1000)") 1,000
        a(href="javascript:void(0)" @click="fillAmount(5000)") 5,000
        a(href="javascript:void(0)" @click="fillAmount(50000)") 50,000
  div(v-if="isDirtyValid()")
    router-link.btnform(v-if="paymentId!==''" :to="getPath(paymentId)" target="_blank" @click.native="submitDeposit") {{ $t('ui.deposit_now') }}
  div(v-else)
    button.btnform(type="button" @click.stop="$v.$touch();") {{ $t('ui.deposit_now') }}
//- #qrph.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='qrph-tab')
  form
    .mb-2
      label.col-form-label {{ $t('ui.payment_channel') }} :
      .row.bank-select-wrap
        template(v-if="providerList.length > 0")
          label.col-4.bank-wrap.py-2.button-radio(v-for="(method, index) in providerList" :class="[{'selected-option' : method.provider_group === paymentId}]" )
            input(type="radio" name="radio" :value="method.provider_group" v-model="paymentId" :checked="index === 0")
            span.me-3(v-if="checkList(method.provider_group)") {{ displayName[method.provider_group] }}
            span.me-3(v-else) {{ method.provider_group }}
            i.fas.fa-thumbs-up(v-if="method.is_recommend" style="color:red")
            .checked-selected(v-if="method.provider_group === paymentId")
              i.fa-solid.fa-check
    .mb-2
      template(v-if="maxRequired !== 0")
        label.col-form-label {{ $t('ui.deposit_amount') }} {{minRequired}} - {{maxRequired}} 
        input.form-control(type='text' :placeholder="$t('ui.amount_min')+': '+minRequired + ', ' + $t('ui.amount_max_short') + ': '+ maxRequired" v-model.trim="$v.depoAmount.$model"  @input="onlyNum")
      template(v-else)
        label.col-form-label {{ $t('ui.amount') }} ({{$t('ui.amount_min')}}: {{minRequired}})
        input.form-control(type='text' :placeholder="$t('ui.amount_min')+': '+minRequired" v-model.trim="$v.depoAmount.$model"  @input="onlyNum")
    validation(v-if="maxRequired !== 0" :value="$v.depoAmount" :name="$t('ui.amount')" target="DEPOSITCP")
    validation(v-else :value="$v.depoAmount" :name="$t('ui.amount')" target="DEPOSIT")
    .mb-2
      label.col-form-label {{$t('ui.choose_promo')}} :
      template(v-for="(promo, index) in promotionList")
        .form-check.p-list( v-if="promo.promotion_id!==null && promo.status ===  1 && checkAvailability(promo.payment_option_list, promo.payment_gateway_list)")
          input.form-check-input.opacity-100(:id="'flexCheckDefault'+(index+1)" type='checkbox' :value="promo.promotion_id" v-model="promoSelected" @click="promoCheck(promo.promotion_id, promo.claim_type)" :disabled="promoId===promo.promotion_id") 
          label.form-check-label.opacity-100(:for="'flexCheckDefault'+(index+1)")
            | {{promo.promotion_name}}
        .form-check-group.vv-promogroup.pg-b1.hide(v-if="multiType.includes(promo.claim_type) && promo.status === 1 && checkAvailability(promo.payment_option_list, promo.payment_gateway_list)" :id="'detail-'+promo.promotion_id")
          .form-check.p-list.vv-checkpromo(v-for="detail in promoDetails")
            input.form-check-input(type="checkbox" :disabled="detail.status === 0" :checked="detail.status !== 0")
            label.form-check-label(:class="{'disabled': detail.status === 0}") {{ formatDisplay(detail.item_order, detail.rate) }}
      .form-check.p-list
        input#flexCheckChecked.form-check-input.opacity-100(type='checkbox' value="" v-model="promoSelected" @click="promoCheck('')" :disabled="promoId===''") 
        label.form-check-label.opacity-100(for='flexCheckChecked')
          | {{$t('ui.choose_nopromo')}}
    .mt-4.text-center(v-if="isDirtyValid()")
      router-link.btn-submit.py-3.no-deco(v-if="paymentId!==''" :to="getPath(paymentId)" target="_blank" @click.native="submitDeposit") {{ $t('ui.deposit_now') }}
    .mt-4.text-center(v-else)
      button.btn-submit(type="button" @click.stop="$v.$touch();") {{ $t('ui.deposit_now') }}
</template>
<script>
import validation from "@/library/_validation.vue"
import {required, minValue, maxValue} from "vuelidate/lib/validators"
export default {
  components:{
    validation
  },
  props: {
    minSettingDeposit: {
      type: Number,
      default: 0.0
    },
    promotionList: {
      type: Array,
      default: []
    },
    providerList:{
      type: Array,
      default: []
    }
  },
  data(){
    return{
      depoAmount: "",
      promoId: "",
      method: "",
      paymentId: "",
      showPromo: false,
      selectedPromo:{},
      minRequired:0,
      maxRequired: 0,
      channelMin: 0,
      // promoSelected: [""],
      promoSelected:"",
      promoDetails:[],
      showDetails:false,
      customList:[
        "SHUNFAPAY"
      ],
      displayName:{
        "SHUNFAPAY": "SunPay",
      },
      mobileDevice: false,
      multiType:["DEPOSIT COUNT MONTHLY", "DEPOSIT COUNT SIGNUP", "DEPOSIT COUNT WEEKLY"]
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  watch:{
    paymentId(newValue, oldValue){
      this.providerList.filter(x=>x.provider_group === newValue).forEach(y=>{
        this.maxRequired = y.max_limit
        if(this.promoSelected===''){
          if(y.min_limit < this.minSettingDeposit){
            this.minRequired = this.minSettingDeposit
            this.channelMin = this.minSettingDeposit
          }else{
            this.minRequired = y.min_limit
            this.channelMin = y.min_limit
          }
        }else{
          if(y.min_limit > this.minRequired){
            this.minRequired = y.min_limit
            this.channelMin = y.min_limit
          }
        }
        
      })
    },
  },
  validations(){
    if(this.maxRequired!==0){
      return{
        depoAmount:{
          required,
          minValue: minValue(this.minRequired),
          maxValue: maxValue(this.maxRequired)
        }
      }
    }else{
      return{
        depoAmount :{
          required,
          minValue: minValue(this.minRequired)
        },
      }
    }
  },
  destroyed(){
    this.reset()
  },
  created(){
    if(this.promotionList.length > 0){
      var vm = this
      this.promotionList.forEach(function(promo, index){
        if(promo.promotion_id==="DAILY22XMAS" && promo.status===1){
          vm.promoCheck("DAILY22XMAS")
        }
      })
    }
  },
  mounted(){
    window.scroll(0,0)
    this.getMobile()
    if(this.providerList.length > 0){
      this.paymentId = this.providerList[0].provider_group
      if(this.providerList[0].min_limit > this.minSettingDeposit){
        this.minRequired = this.providerList[0].min_limit
      }else{
        this.minRequired = this.minSettingDeposit
      }
      this.maxRequired = this.providerList[0].max_limit
    }else{
      this.minRequired = this.minSettingDeposit
    }
    
  },
  methods:{
    switchChannel(id){
      this.promoSelected = ""
      this.paymentId = id
      
    },
    fillAmount(amt){
      this.depoAmount = amt
    },
    formatDisplay(order, rate){
      const n = parseInt(order, 10)
      const s = ["th", "st", "nd", "rd"], v= n% 100
      return n + (s[(v - 20) % 10] || s[v] || s[0]) + " Deposit Bonus " + rate + "%";
    },
    checkList(provider){
      if(this.customList.includes(provider)){
        return true
      }else{
        return false
      }
    },
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    onlyNum(){
      this.depoAmount = this.depoAmount.replace(/[^0-9]/g, "")
    },
    checkAvailability(list, gateway){
      if(list===null){
        return true
      }else{
        var temp = list.toLowerCase().split(',')
        if(temp.includes('qrph')){
          if(gateway === null){
            return true
          }else{
            var gate = gateway.split(',')
            if(gate.includes(this.paymentId)){
              return true
            }else{
              return false
            }
          }
        }else{
          return false
        }
      }
    },
    checkDetails(){
      var type = this.promotionList.find(x => x.promotion_id == this.promoSelected)?.claim_type
      this.promoCheck(this.promoSelected, type)
    },
    promoCheck(id, type){
      // this.promoSelected = []
      // $("[id^='detail-']").removeClass("aaa")
      // this.promoSelected.push(id)
      this.promoSelected = id
      this.selectPromo(id)
      if(type){
        if(this.multiType.includes(type)){
          this.showDetails = true
          this.getPromoDetails(id)
        }else{
          this.showDetails = false
        }
      }
    },
    getPromoDetails(id){
      let account_id = this.accountID
      let auth_token = this.sessionToken
      let promotion_id = id
      this.$store
        .dispatch("user/getPromoDepositCount", { account_id, auth_token, promotion_id })
        .then(response => {
          if (response.success == true) {
            this.promoDetails = response.data
            // $("#detail-"+id).toggleClass("aaa")
          } else {             
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
          }
        });
    },
    getPath(id){
      switch(id){
        case "SHUNFAPAY":
          return '/shunfapay?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=qrph&mode=qrph'
        case "MASAYAPAY":
          return '/masayapay?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=qrph&mode=qrph'
        case "ANFU":
          return '/anfu?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=qrph&mode=qrph'
        case "TYGPAY":
          return '/tygpay?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=qrph&mode=qrph&mobile=' + this.mobileDevice + '&code=qrph'
        case "INNPAYD0S":
          return '/innpay?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=INNPAYD0S&mode=qrph'
        case "INNPAYD0C":
          return '/innpay?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=INNPAYD0C&mode=qrph'
        case "RKPAY":
          return '/rkpay?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=qrph&mode=qrph'
        case "AIPAY":
          return '/aipay?amount=' + this.depoAmount + '&promo=' + this.promoSelected + '&method=qrph'

      }
    },
    selectPromo(id){
      this.promoSelected = id
      if(id === ""){
        this.clearPromo()
      }else{
        this.promotionList.filter(x=>x.promotion_id === id).forEach(y=>{
          if(this.depoAmount === ""){
            this.depoAmount = y.min_deposit
          }
          this.selectedPromo = {
            bonus_rate: y.bonus_rate,
            min_deposit: y.min_deposit,
            promotion_name: y.promotion_name,
          }
        })
        if(this.selectedPromo.min_deposit < this.channelMin){
          this.minRequired = this.channelMin
        }else{
          this.minRequired = this.selectedPromo.min_deposit
        }
      }
      this.showPromo = !this.showPromo
      this.$v.depoAmount.$touch()
    },
    clearPromo(){
      this.promoSelected = ""
      this.selectedPromo = {}
      this.providerList.filter(x=>x.provider_group === this.paymentId).forEach(y=>{
        if(y.min_limit > this.minSettingDeposit){
          this.minRequired = y.min_limit
        }else{
          this.minRequired = this.minSettingDeposit
        }
      })
    },
    isDirtyValid() {
      return this.$v.depoAmount.$dirty && !this.$v.depoAmount.$invalid    
    },
    submitDeposit(){
      fbq('trackCustom', 'Deposit', {deposit: this.depoAmount});
      this.$router.push({
        name:"statement",
        params:{
          "checkTrans": true
        }
      }).catch(error =>{})
    },
    reset(){
      this.depoAmount = ""
      this.promoSelected = ""
      this.method= ""
      this.selectedPromo = {}
    }
  }
}
</script>
<style lang="scss" scoped>
// .button-radio {
//   display: inline-block;
//   // background-color: #007bff;
//   color: #fff;
//   // border: 1px solid #7a18a5;
//   padding: 10px 20px;
//   margin: 5px 0;
//   cursor: pointer;
// }

// .button-radio input {
//   display: none; /* Hide the actual radio inputs */
// }

// .button-radio input:checked + label {
//   background-color: #fff;
//   color: #007bff;
// }

// .button-radio input:focus + label {
//   outline: 2px solid #007bff;
// }
// .selected-option{
//   // background: #7a18a5;
//   border: 1px solid #7a18a5;
// }
// .checked-selected{
//   position: absolute;
//   top: 0;
//   right: 0;
//   background: #7a1805;
//   width: 20px;
// }
// .disabled{
//   filter: grayscale(1)
// }
// .vv-promogroup{
//   pointer-events: none;
// }
</style>
  